module.exports = __webpack_public_path__ + "img/kpis-banner-responsive.91e8cace.png";